module.exports = __webpack_public_path__ + "img/16_83.f7c59ce1.png";